import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import {
  Icon,
  IconButton,
  Tooltip,
} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import { defineMessages, injectIntl } from 'react-intl';
import * as actions from '../../../../state';
import styles from '../styles.module.css';

// components & objects
import { chartTypes } from '../../chart-controls/chart-type-select/ChartTypeSelect';
import CopyChart from './CopyChart';

const messages = defineMessages({
  EDIT_CHART: {
    id: 'EDIT_CHART',
    defaultMessage: 'Edit',
  },
  COPY_CHART: {
    id: 'COPY_CHART',
    defaultMessage: 'Copy',
  },
  CHART_FILTERS: {
    id: 'CHART_FILTERS',
    defaultMessage: 'Filters',
  },
  DELETE_CHART: {
    id: 'DELETE_CHART',
    defaultMessage: 'Delete',
  },
});

function ChartCardMenu({
  allowCopy,
  chart,
  deleteChart,
  intl,
  editChart,
  getFilterBtn,
}) {
  const board = useSelector(actions.readStateBoard);
  const layout = useSelector(actions.selectLayout);

  const getGridItemFromLayout = () => {
    const gridLayout = board?.layouts?.lg;
    return gridLayout?.find((grid) => grid.i === String(chart.id));
  };

  // eslint-disable-next-line consistent-return
  const cardTypeIcon = (selectedChartType) => {
    let typeDef = {};
    chartTypes.forEach((typeGroup) => typeGroup.types.forEach((chartType) => {
      if (chartType.type === selectedChartType) { typeDef = chartType; }
    }));

    if (typeDef.icon) {
      return (
        <Icon
          className={styles.newcardIcon}
          style={{ backgroundColor: typeDef.color }}
        >
          {typeDef.icon}
        </Icon>
      );
    }

    if (typeDef.nsIcon) {
      return (
        <Icon
          className={styles.newcardIcon}
          style={{ backgroundColor: typeDef.color, top: '8px !important' }}
        >
          <span className={`nsicon-m ${typeDef.nsIcon}`} />
        </Icon>
      );
    }
  };

  const cardLayout = getGridItemFromLayout();

  const denseOverlay = cardLayout && cardLayout.w // not sure why but sometimes cardLayout is not found
    ? (cardLayout.w === 2 && cardLayout.h <= 4) || (cardLayout.h === 3)
    : false;

  const filterOverlayBtn = getFilterBtn(true);

  if (layout.editMode) {
    return (
      <div className={styles.editOverlay}>
        <div className={styles.overlayBtnsContainer}>
          {!denseOverlay && cardTypeIcon(chart.type)}

          <div className={styles.overlayBtns}>
            <Tooltip disableFocusListener title={intl.formatMessage({ ...messages.EDIT_CHART })}>
              <IconButton onClick={editChart}>
                <EditIcon />
              </IconButton>
            </Tooltip>

            {allowCopy
              && (
                <Tooltip disableFocusListener title={intl.formatMessage({ ...messages.COPY_CHART })}>
                  <div style={{ display: 'inline-block' }}>
                    <CopyChart dense chartToCopy={chart} />
                  </div>
                </Tooltip>
              )}

            {filterOverlayBtn && (
              <Tooltip disableFocusListener title={intl.formatMessage({ ...messages.CHART_FILTERS })}>
                {filterOverlayBtn}
              </Tooltip>
            )}

            <Tooltip disableFocusListener title={intl.formatMessage({ ...messages.DELETE_CHART })}>
              <IconButton
                color="secondary"
                className={styles.overlayDeleteBtn}
                onClick={deleteChart}
                style={{ marginRight: '0px !important' }}
              >
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          </div>
        </div>
      </div>
    );
  }
}

ChartCardMenu.defaultProps = {
  allowCopy: false,
};

ChartCardMenu.propTypes = {
  allowCopy: PropTypes.bool,
  chart: PropTypes.shape({}).isRequired,
  deleteChart: PropTypes.func.isRequired,
  intl: PropTypes.shape({}).isRequired,
  editChart: PropTypes.func.isRequired,
  getFilterBtn: PropTypes.func.isRequired,
};

export default injectIntl(ChartCardMenu);
